<template>
  <div class="bg">
    <div class="wrap">
      <div class="pay-method">
        <span class="reload-btn" @click="reload"></span>
        <div class="pay-nav">
          <span
            v-for="item in payList"
            :key="item.mode"
            :class="{'cur':item.mode==payMode}"
            @click="selectPayMode(item.mode)"
          >{{item.name}}</span>
        </div>
        <div v-for="item in payList" :key="item.mode">
          <div
            class="pay-item"
            v-show="item.mode==payMode"
            :class="{'active':item.mode==payMode,'pay-item-yl':item.mode == 25, 'pay-item-zfb':item.mode == 29, 'pay-item-wx':item.mode == 23}"
          >
            <div class="pay-code">
              <qriously :value="qrData" :size="165" level="M"  v-show="qrData"/>
            </div>
            <h3 class="pay-tit">{{item.desc}}</h3>
            <p class="pay-tips">
              <span v-show="payMode == 25">目前支持云闪付、工商、农行、建行、中行等APP扫码支付。</span>
              <br />如需使用其他支付方式可
              <a href="###" class="font-blue">点击这里</a>！
            </p>
          </div>
        </div>
        <div class="pay-operate" v-if="!isError">
          <div>
            二维码有效时长：
            <span v-show="sec > 0" class="timedown font-red">{{sec}}</span>
            <span v-show="sec > 0">秒</span>
            <span v-show="sec <= 0" class="font-red">已过期</span>
          </div>
          <div>
            <a href="###" class="font-blue" @click="getOrderStatus">支付完成，点击刷新</a>
          </div>
        </div>
        <div class="pay-operate" v-if="isError">加载失败，请稍后重试。</div>
      </div>
      <div class="main">
        <div class="pay-detail">
          <h2>订单详情</h2>
          <div class="pay-detail-w">
            <div class="clearfix line-box">
              <p>
                账号：
                <span class="font-blue account">{{orderInfo.userName}}</span>
              </p>
              <p>
                订单号：
                <span>{{orderInfo.id}}</span>
              </p>
            </div>
            <div class="clearfix line-box">
              <p>
                产品：
                <span>{{orderInfo.productName}}</span>
              </p>
              <p>
                价格：
                <strong
                  class="totalPrice-cur font-red"
                >{{(orderInfo.payMoney - convertMoney) | amountUnitFormat(orderInfo.monthCount)}}</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="foot">
        <div class="foot-img fr foot-btn">
          <a href="javascript:history.back(-1)" class="font-blue">上一步</a>
        </div>
        <div class="foot-select">
          <a href="http://www.gw.com.cn/download/fx.html" class="font-blue" target="_blank">风险提示</a>
          <span class="fr">本支付平台由大智慧信息科技有限公司提供。</span>
        </div>
        <p class="foot-tips">
          如遇到支付问题，可随时拨打
          <strong class="font-blue">021-20219999</strong>，客服将第一时间帮你解决。
          <br />如需了解详情可点击进入大智慧官网
          <a href="#" class="font-blue" @click="toWebsite">www.gw.com.cn</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Invoice from "@/components/invoice/Invoice.vue";
export default {
  data() {
    return {
      orderId: this.$route.params.orderId,
      payMode: 29,
      payList: [
        { mode: 29, name: "支付宝", desc: "支付宝扫码支付" },
        { mode: 23, name: "微信", desc: "微信扫码支付" },
        { mode: 25, name: "银联", desc: "银联扫码支付" }
      ],
      sec: 180,
      orderInfo: {
        userName:'8278',
        id:'87734874378347',
        productName:'策略投资终端及题材王体验版礼包'
      },
      qrData: "",
      unionPayQrCode: "",
      aliPayQrCode: "",
      wechatPayQrCode: "",
      lock: false,
      isError: true,
      countDownTimer: null,
      orderStatusTimer: null,
      convertMoney: 0
    };
  },
  created() {
    document.title = "PC购买入口";
    this.getOrder();
    this.getOrderStatusTimer();
  },
  mounted() {
    document.getElementsByTagName("body")[0].className="bodyWidth";
  },
  beforeDestroy() {
    if (this.orderStatusTimer) {
      clearInterval(this.orderStatusTimer);
    }
    document.body.removeAttribute("class","bodyWidth");
  },
  methods: {
    getOrder() {
      this.$get("/order/query?id=" + this.orderId)
        .then(response => {
          if (response.code === 0) {
            this.orderInfo = response.data;
            const payMoney = this.orderInfo.payMoney;
            if (this.orderInfo.convertMoney) {
              this.convertMoney = this.orderInfo.convertMoney
            }
            if (payMoney > 10000) {
              this.payMode = 29;
            }
            this.getQrCode();
          } else if (response.code != 100) {
            alert(response.msg);
          }
        })
        .catch(err => {
          alert(err + "网络异常，请稍后重试。");
          this.$router.go(-1);
        });
    },
    getQrCode() {
      if (this.lock) {
        return false;
      }
      var params = {
        id: this.orderId,
        payMode: this.payMode
      };
      if (this.payMode == 25 && this.unionPayQrCode) {
        this.qrData = this.unionPayQrCode;
        this.isError = false;
        this.countDown();
        return false;
      }
      if (this.payMode == 29 && this.aliPayQrCode) {
        this.qrData = this.aliPayQrCode;
        this.isError = false;
        this.countDown();
        return false;
      }
      if (this.payMode == 23 && this.wechatPayQrCode) {
        this.qrData = this.wechatPayQrCode;
        this.isError = false;
        this.countDown();
        return false;
      }
      this.lock = true;
      this.$get("/pay/qrcode", params)
        .then(response => {
          if (response.code === 0) {
            this.qrData = response.data;
            if (this.payMode == 25) {
              this.unionPayQrCode = this.qrData;
            }
            if (this.payMode == 29) {
              this.aliPayQrCode = this.qrData;
            }
            if (this.payMode == 23) {
              this.wechatPayQrCode = this.qrData;
            }
            this.isError = false;
            this.countDown();
          } else if (response.code == 105) {
            this.$router.push("/client/payfinsh");
          } else if (response.code != 100) {
            this.$alert(response.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
          this.lock = false;
        })
        .catch(err => {
          this.qrData = "";
          this.isError = true;
          this.lock = false;
        });
    },
    selectPayMode(payMode) {
      if (payMode == this.payMode) {
        return false;
      }
      if (this.lock) {
        return false;
      }
      this.payMode = payMode;
      this.getQrCode();
    },
    countDown() {
      if (this.countDownTimer) {
        clearInterval(this.countDownTimer);
      }
      this.sec = 180;
      this.countDownTimer = setInterval(() => {
        if (this.sec <= 0) {
          clearInterval(this.countDownTimer);
        } else {
          this.sec--;
        }
      }, 1000);
    },
    getOrderStatus() {
      this.$get("/order/status?id=" + this.orderId)
        .then(response => {
          if (response.code === 0) {
            if (response.data == 1 || response.data == 9) {
              this.$router.push("/client/payfinsh");
            } else {
              alert("您尚未支付成功，如已发生扣款，请稍后查询。");
            }
          } else {
            alert(response.msg);
          }
        })
        .catch(err => {
          alert("网络异常，请稍后重试");
        });
    },
    getOrderStatusTimer() {
      var count = 60;
      this.orderStatusTimer = setInterval(() => {
        if (count <= 0) {
          clearInterval(this.orderStatusTimer);
        } else {
          count--;
          this.$get("/order/status?id=" + this.orderId).then(response => {
            if (response.code === 0 && (response.data == 1 || response.data == 9)) {
              this.$router.push("/client/payfinsh");
            }
          });
        }
      }, 5000);
    },
    reload() {
      window.location.reload();
    },
    toWebsite() {
      window.location.href = window.g.dzhIndexUrl;
    }
  },

  components: {
    Invoice
  }
};
</script>

<style scoped>
.main{margin-top: 0;margin-bottom: 0;}
</style>



// WEBPACK FOOTER //
// src/pages/client/Order.vue